function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Background",
  d: "M157.256,220c0-2.946-2.041-5.333-4.558-5.333s-4.558,2.387-4.558,5.333H15A15,15,0,0,1,0,205V183a3,3,0,0,1,3-3H148.14c0,2.946,2.04,5.333,4.558,5.333s4.558-2.387,4.558-5.333H230a15,15,0,0,1,15,15v22a3,3,0,0,1-3,3Z",
  transform: "translate(0.5 -179.5)",
  fill: "rgba(231,166,162,0.6)",
  stroke: "#bf9586",
  strokeWidth: 1,
  fillRule: "evenodd"
});

var SvgGenealogyMother = function SvgGenealogyMother(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 41,
    viewBox: "0 0 246 41",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGenealogyMother, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/genealogy-mother.b7d40813.svg";
export { ForwardRef as ReactComponent };